import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import useDevotionals from "../../../../hooks/useDevotionals";
import useHyms from "../../../../hooks/useHyms";
import DevotionalTable from "../../../components/DevotionalTable/DevotionalTable";
import DevotionalDialog from "../../../components/FormDialog/DevotionalDialog";
import FormDialog from "../../../components/FormDialog/FormDialog";
import HymnTable from "../../../components/HymnTable/HymnTable";
import Searchbar from "../../../components/searchbar/Searchbar";
import TabPanel from "../../../components/TabPanel/TabPanel";
import classes from "./hymn.module.css";

const Hymn = () => {
   const [value, setValue] = React.useState(0);

   const handleChange = (_, newValue) => {
      setValue(newValue);
   };

   const { openHymnsForm, searchHymns } = useHyms();
   const { openDevotionsForm, searchDevotionals } = useDevotionals();
   return (
      <Box sx={{ width: "100%" }}>
         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value} onChange={handleChange}>
               <Tab label="Hymns" route="/hymn" />
               <Tab label="Devotionals" route="/devotional" />
            </Tabs>
         </Box>
         <TabPanel value={value} index={0}>
            <Box className={classes.buttons}>
               <Button
                  onClick={openHymnsForm}
                  className={classes.button}
                  variant="outlined"
               >
                  Add Hymn +
               </Button>
               <FormDialog />

               <Searchbar label="Search hymns" onSearchFunction={searchHymns} />
            </Box>
            <HymnTable />
         </TabPanel>
         <TabPanel value={value} index={1}>
            <Box className={classes.buttons}>
               <Button
                  onClick={openDevotionsForm}
                  className={classes.button}
                  variant="outlined"
               >
                  Add Devotionals +
               </Button>
               <DevotionalDialog />
               <Searchbar
                  label="Search devotionals"
                  onSearchFunction={searchDevotionals}
               />
            </Box>
            <DevotionalTable />
         </TabPanel>
      </Box>
   );
};

export default Hymn;
